import { NavLink } from "react-router-dom";

export function Hero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-8 items-center">
      <div>
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          Ethos Tech Hub Limited
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          Innovating Your Business Through Smart Systems
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          Driven by Innovation, Shaped by Creativity, Built for Practical
          Impact.
        </p>
        <div className="mt-6 flex gap-4">
          <button className="reverse-company-main-color border-gray-300 px-6 py-3 rounded-full">
            <NavLink
              to="/dukaree"
              className={({ isActive }) =>
                isActive
                  ? "reverse-company-main-color border-gray-300 px-6 py-3 rounded-full"
                  : "reverse-company-main-color border-gray-300 px-6 py-3 rounded-full hover:border-blue-400 pb-1 transition"
              }
            >
              SFA
            </NavLink>
          </button>
          <button className="reverse-company-main-color border-gray-300 px-6 py-3 rounded-full">
            <NavLink
              to="/erp"
              className={({ isActive }) =>
                isActive
                  ? "reverse-company-main-color border-gray-300 px-6 py-3 rounded-full"
                  : "reverse-company-main-color border-gray-300 px-6 py-3 rounded-full hover:border-blue-400 pb-1 transition"
              }
            >
              ERP
            </NavLink>
          </button>
        </div>
      </div>
      <div>
        {/* Replace with actual image or SVG */}
        <img
          src="/images/illustrationLandingPage.png"
          alt="illustration"
          className="w-full h-auto"
        />
      </div>
    </section>
  );
}
